import React from 'react';
import { connect } from 'react-redux';
import properties from '../../constants/Properties';
import appParameters from '../utils/AppParameters';
import locales from '../../locales/LocalesManager';
import { showExportAlert } from '../../actions/MenuActions';
import { setExportProperties } from '../../actions/ProductionActions';
import storeManager from '../../store/StoreManager';
import mouseUtils from '../../components/utils/MouseUtils';
import exporterUtils from '../../components/utils/ExporterUtils';
import saveManager from '../utils/SaveManager';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import apiServiceUtils from '../utils/ApiServiceUtils';

const Button = React.createClass({
    getInitialState() {
        return {
            contentItemId: appParameters.contentItemId,
            isOver: false
        };
    },
    componentDidMount () {
        if (this.props.index == 1)
            saveManager.refreshExportButton = this.refreshExportButton;
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onButtonClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        saveManager.resetAutosave();
        saveManager.saveData();

        if (this.props.index == 1) { //YES, button
            if (appParameters.contentItemId > 0) {
                exporterUtils.startExport();
                this.props.dispatch(showExportAlert(false));
            }
        } else {
            this.props.dispatch(showExportAlert(false));
        }
    },
    refreshExportButton() {
        if (this.props.index != 1)
            return;

        saveManager.refreshExportButton = undefined;

        this.setState({
            contentItemId: appParameters.contentItemId
        });
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.index == 1 && this.state.contentItemId == -1 && appParameters.contentItemId > 0)
            return true;

        if (this.state.isOver != nextState.isOver)
            return true;
        else
            return false;
    },
    render() {
        var textColor;
        var fillColor;
        var opacity = 1;
        var tabIndexValue;

        if (this.props.index == 1 && appParameters.contentItemId < 0) {
            opacity = 0.5;
            tabIndexValue = '-1';
        }

        if (this.state.isOver == true) {
            if (opacity == 0.5) {
                textColor = 'white';
                fillColor = properties.DELETE_ALERT_BACKGROUND;
            } else {
                fillColor = properties.SLIDE_VIEWER_BACKGROUND;
                textColor = 'black';
            }
        } else if (this.props.index == 0) {
            textColor = 'black';
            fillColor = 'white';
        } else {
            textColor = 'white';
            fillColor = '#555555';
        }

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: fillColor,
            width: properties.DELETE_ALERT_BUTTON_WIDTH,
            height: properties.DELETE_ALERT_BUTTON_HEIGHT,
            top: this.props.topPosition,
            left: this.props.leftPosition,
            borderRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#333333',
            opacity,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            textAlign: 'left'
        };

        const spanStyle = {
            position: 'absolute',
            top: 6,
            fontSize: 16,
            width: properties.DELETE_ALERT_BUTTON_WIDTH - 6,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            alignItems: 'center',
            textAlign: 'center',
            cursor: 'default',
            color: textColor
        };

        var idValue;

        if (this.props.index == 0)
            idValue = 'exportFirstFocusableButton';
        else
            idValue = 'exportLastFocusableButton';

        return (
            <button id={idValue} tabIndex={tabIndexValue} aria-disabled={tabIndexValue == '-1' ? true : false} aria-label={this.props.text} style={buttonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onButtonClick} onClick={this.onButtonClick}>
                <span style={spanStyle}>{this.props.text}</span>
            </button>
        );
    }
});

const CheckBox = React.createClass({
    onCheckBoxClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var exportProperties = this.props.exportProperties;

        if (!exportProperties) {
            exportProperties = {};

            exportProperties.addKenBurns = false;
            exportProperties.addTransitions = false;
            exportProperties.useCrossFade = false;
            exportProperties.useRandom = false;
        }

        var isSelected = this.isSelected();

        switch (this.props.index) {
            case 0: {
                exportProperties.addKenBurns = !isSelected;
                break;
            }
            case 1: {
                exportProperties.addTransitions = !isSelected;
                break;
            }
            case 2: {
                if (!isSelected) {
                    exportProperties.useCrossFade = true;
                    exportProperties.useRandom = false;
                }
                break;
            }
            case 3: {
                if (!isSelected) {
                    exportProperties.useCrossFade = false;
                    exportProperties.useRandom = true;
                }
                break;
            }
        }

        if (exportProperties.addTransitions && !exportProperties.useCrossFade && !exportProperties.useRandom)
            exportProperties.useCrossFade = true;

        this.props.dispatch(setExportProperties(exportProperties));
        saveManager.isContentChanged(true);
    },
    isSelected() {
        var exportProperties = this.props.exportProperties;

        if (exportProperties) {
            switch (this.props.index) {
                case 0: {
                    return exportProperties.addKenBurns;
                }
                case 1: {
                    return exportProperties.addTransitions;
                }
                case 2: {
                    return exportProperties.useCrossFade;
                }
                case 3: {
                    return exportProperties.useRandom;
                }
            }
        } else
            return false;
    },
    render() {
        const checkBoxSize = 18;
        const yGap = checkBoxSize + 17;
        const xGap = (this.props.index == 2 || this.props.index == 3) ? 40 : 0;
        var holderStyle = {
            position: 'absolute',
            left: properties.DELETE_ALERT_BUTTON_GAP + xGap,
            top: this.props.top + yGap * this.props.index
        };

        var checkBoxStyle = {
            position: 'absolute',
            width: checkBoxSize,
            height: checkBoxSize,
            top: 0,
            left: properties.DELETE_ALERT_BUTTON_GAP,
            borderRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: properties.DELETE_ALERT_BACKGROUND,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'none'
        };

        var selectorStyle = {
            position: 'absolute',
            width: 10,
            height: 10,
            top: checkBoxSize/2 - 10/2,
            left: checkBoxSize/2 - 10/2,
            background: properties.DELETE_ALERT_BACKGROUND
        };

        if (this.isSelected())
            selectorStyle.display = 'block';
        else
            selectorStyle.display = 'none';

        const questionStyle = {
            position: 'absolute',
            left: properties.DELETE_ALERT_BUTTON_GAP + checkBoxSize + 15,
            top: 2,
            fontSize: 16,
            width: properties.DELETE_ALERT_WIDTH - 2 * properties.DELETE_ALERT_BUTTON_GAP,
            height: 70,
            cursor: 'default',
            color: 'black',
            whiteSpace: 'pre-line'
        };

        if (this.props.index == 2 || this.props.index == 3) {
            if (this.props.exportProperties && this.props.exportProperties.addTransitions)
                holderStyle.display = 'block';
            else
                holderStyle.display = 'none';
        } else
            holderStyle.display = 'block';

        var idValue;

        if (this.props.index == 0)
            idValue = 'exportFirstFocusableCheckBox';

        return (
            <div style={holderStyle}>
                <button id={idValue} aria-label={this.props.text} style={checkBoxStyle} onTouchEnd={this.onCheckBoxClick} onClick={this.onCheckBoxClick}>
                    <div style={selectorStyle}/>
                </button>
                <div style={questionStyle}>{this.props.text}</div>
            </div>
        );
    }
});

const ExportAlertContent = React.createClass({
    render() {
        var visible = 'none';

        if (this.props.showExportAlert == true)
            visible = 'block';
        else
            return (<div/>);

        const menuStyle = {
            position: 'absolute',
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: apiServiceUtils.getNoInternetConnectionAlertHeight(),
            left: 0,
            display: visible,
            zIndex: 20000
        };

        const backgroundStyle = {
            position: 'absolute',
            backgroundColor: properties.DELETE_ALERT_BACKGROUND,
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: 0,
            left: 0,
            opacity: properties.DELETE_ALERT_BACKGROUND_OPACITY
        };

        const alertHolderStyle = {
            position: 'absolute',
            top: this.props.windowHeight / 2 - (properties.DELETE_ALERT_TOP_BAR_HEIGHT + properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT) / 2,
            left: this.props.windowWidth / 2 - properties.DELETE_ALERT_WIDTH / 2
        };

        const topBarStyle = {
            position: 'absolute',
            backgroundColor: properties.DELETE_ALERT_BACKGROUND,
            width: properties.DELETE_ALERT_WIDTH,
            height: properties.DELETE_ALERT_TOP_BAR_HEIGHT,
            top: 0,
            left: 0,
            borderTopLeftRadius: 3,
            borderTopRightRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: properties.DELETE_ALERT_BACKGROUND
        };

        const bottomBarStyle = {
            position: 'absolute',
            backgroundColor: 'white',
            width: properties.DELETE_ALERT_WIDTH,
            height: properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT,
            top: properties.DELETE_ALERT_TOP_BAR_HEIGHT,
            left: 0,
            borderBottomLeftRadius: 3,
            borderBottomRightRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: 'white'
        };

        const titleStyle = {
            position: 'absolute',
            left: properties.DELETE_ALERT_BUTTON_GAP,
            top: 6,
            fontSize: 22,
            width: properties.DELETE_ALERT_WIDTH - 2 * properties.DELETE_ALERT_BUTTON_GAP,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            color: 'white'
        };

        const questionStyle = {
            position: 'absolute',
            left: properties.DELETE_ALERT_BUTTON_GAP,
            top: 20,
            fontSize: 16,
            width: properties.DELETE_ALERT_WIDTH - 2 * properties.DELETE_ALERT_BUTTON_GAP,
            height: 70,
            cursor: 'default',
            color: 'black',
            whiteSpace: 'pre-line'
        };

        var topCheckBox = questionStyle.top + questionStyle.height + 10;

        var effectsHolderStyle = {
            display: 'block'
        };

        if (audioToolUtils.isAudioTool()) {
            effectsHolderStyle.display = 'none';
        }

        var title = locales.getCaption('ExportAlertTitle', 'exportAlert');

        if (audioToolUtils.isAudioTool())
            title = title.replace('MP4', 'MP3');

        return (
            <div style={menuStyle} id='exportPopup'>
                <div style={backgroundStyle}/>
                <div style={alertHolderStyle}>
                    <div style={topBarStyle}>
                        <span style={titleStyle}>{title}</span>
                    </div>
                    <div style={bottomBarStyle}>
                        <div style={questionStyle}>{locales.getCaption('ExportAlertInfo', 'exportAlert')}</div>

                        <div style={effectsHolderStyle}>
                            <CheckBox top={topCheckBox} text={locales.getCaption('useKenBurns', 'export')} index={0} dispatch={this.props.dispatch} exportProperties={this.props.exportProperties}/>
                            <CheckBox top={topCheckBox} text={locales.getCaption('addTransitions', 'export')} index={1} dispatch={this.props.dispatch} exportProperties={this.props.exportProperties}/>
                            <CheckBox top={topCheckBox} text={locales.getCaption('useCrossFade', 'export')} index={2} dispatch={this.props.dispatch} exportProperties={this.props.exportProperties}/>
                            <CheckBox top={topCheckBox} text={locales.getCaption('useRandom', 'export')} index={3} dispatch={this.props.dispatch} exportProperties={this.props.exportProperties}/>
                        </div>

                        <Button dispatch={this.props.dispatch} topPosition={properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT - properties.DELETE_ALERT_BUTTON_GAP - properties.DELETE_ALERT_BUTTON_HEIGHT} leftPosition={properties.DELETE_ALERT_WIDTH - 2 * properties.DELETE_ALERT_BUTTON_GAP - 2 * properties.DELETE_ALERT_BUTTON_WIDTH} index={0} text={locales.getCaption('DeleteAlertCancel', 'deleteAlert')}/>
                        <Button dispatch={this.props.dispatch} topPosition={properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT - properties.DELETE_ALERT_BUTTON_GAP - properties.DELETE_ALERT_BUTTON_HEIGHT} leftPosition={properties.DELETE_ALERT_WIDTH - properties.DELETE_ALERT_BUTTON_GAP - properties.DELETE_ALERT_BUTTON_WIDTH} index={1} text={locales.getCaption('Export', 'exportAlert')}/>
                    </div>
                </div>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const showExportAlert = state.menu.showExportAlert;
    const exportProperties = state.production.exportProperties;
    const refresh = Math.random();

    return {
        showExportAlert,
        exportProperties,
        refresh
    };
}

export const ExportAlert = connect(mapStateToProps)(ExportAlertContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/ExportAlert.js
 **/